// src/pages/ForgotPasswordPage.js
import React from "react";
import { Link } from "react-router-dom";
import styles from "../css/Login.module.css"; // ✅ Apunta al CSS de Login
import { FiHelpCircle, FiArrowLeft } from "react-icons/fi";

const ForgotPasswordPage = () => {
  return (
    // ✅ Usa el contenedor principal del CSS de Login
    <div className={styles.pageContainer}>
      {/* ✅ Usa la tarjeta de autenticación para un look consistente */}
      <div className={styles.authCard}>
        <div className={styles.header}>
          {/* Un icono relevante para la sección */}
          <FiHelpCircle
            size={40}
            color="var(--primary-color)"
            style={{ marginBottom: "1rem" }}
          />
          <h2>¿Olvidaste tu contraseña?</h2>
          <p>
            Para restablecerla, por favor contacta al administrador del sistema.
          </p>
        </div>

        {/* Sección de información de contacto */}
        <div
          style={{
            background: "var(--background-color)",
            padding: "1.5rem",
            borderRadius: "8px",
            border: "1px solid var(--border-color)",
            marginBottom: "2rem",
          }}
        >
          <p
            style={{
              margin: "0 0 0.5rem 0",
              fontWeight: "bold",
              fontSize: "1.1rem",
              color: "var(--text-color)",
            }}
          >
            Daniel Medina
          </p>
          <a
            href="mailto:help@danielmedina.io"
            className={styles.link}
            style={{ fontSize: "1rem" }}
          >
            📧 help@danielmedina.io
          </a>
          <p
            style={{
              fontSize: "0.9rem",
              color: "var(--text-color-light)",
              marginTop: "1rem",
              marginBottom: 0,
            }}
          >
            Te ayudaremos a recuperar el acceso a tu cuenta.
          </p>
        </div>

        {/* ✅ Botón para volver a la página de login */}
        <Link
          to="/login"
          className={styles.button}
          style={{ textDecoration: "none", width: "100%" }}
        >
          <FiArrowLeft />
          <span>Volver a Inicio de Sesión</span>
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
